import { useState } from 'react';

import { data } from './data/data_02_epilogi'
import kuva from '../../images/neutral_small.png'

const Scene_02_epilogi = ({ visibilityHandler }) => {
    //otetaan vastaan propseista funktiot




    const jatka = () => {

        visibilityHandler("jatka sceneen 03")

    }



    return (


        <div className='sceneContainer'>

            <div id='image'>
                <img className='sameSizeImg' src={kuva} alt='kuva' />
            </div>

            <div id='teksti'>
                <h5>{(data.teksti != null && data.teksti != "") ? data.teksti : null}</h5>
            </div>

            <div id='actions'>
                <button onClick={() => jatka()}>jatka</button>
            </div>
        </div>

    )

}

export default Scene_02_epilogi